import { useMemo } from 'react';

import type {
  ThirdPartyContactFields,
  ThirdPartyContactWithStatus,
} from './types';

type ContactStatus = 'active' | 'pending' | 'revoked';

export const getContactStatus = (
  isRevoked: boolean,
  lastSeen: string | null | undefined,
  passwordSetAt: string | null | undefined
): ContactStatus => {
  if (isRevoked) {
    return 'revoked';
  }
  if (lastSeen || passwordSetAt) {
    return 'active';
  }

  return 'pending';
};

export const mapContactWithStatus = (
  contact: ThirdPartyContactFields
): ThirdPartyContactWithStatus => {
  // COI-834: the caller org's membership row — see the note on
  // `ThirdPartyContactFields.user`. `?? null` already collapsed a null
  // `LastSeen`, so an absent membership row lands on the same branch and no
  // reader downstream can tell the two apart, which is the intended behaviour.
  const lastLogin = contact.user?.organisationusers?.[0]?.LastSeen ?? null;
  const status = getContactStatus(
    contact.IsRevoked,
    lastLogin,
    contact.PasswordSetAtTimestamp ?? null
  );

  return {
    ...contact,
    lastLogin,
    status,
  };
};

export const useContactsWithStatus = (
  contacts: ThirdPartyContactFields[]
): ThirdPartyContactWithStatus[] => {
  return useMemo(() => contacts.map(mapContactWithStatus), [contacts]);
};
